<script setup lang="ts">
import CButton from './CButton.vue'
import CDialog from './CDialog.vue'

interface Props {
  tariffName?: string
}

defineProps<Props>()
const model = defineModel<boolean>()

const SUPPORT_TELEGRAM_URL = 'https://t.me/marketassist_support'

function handleClose() {
  model.value = false
}

function handleOpenTelegram() {
  window.open(SUPPORT_TELEGRAM_URL, '_blank', 'noopener,noreferrer')
  model.value = false
}
</script>

<template>
  <CDialog v-model="model" :title="$t('tariff_downgrade_info_title')">
    <template #header>
      <div class="flex items-center gap-2">
        <i class="icon-info-circle text-2xl text-blue-light-3" />
        <span class="text-lg font-semibold">
          {{ $t('tariff_downgrade_info_title') }}
        </span>
      </div>
    </template>

    <div class="flex flex-col gap-3 text-sm text-text-regular leading-relaxed">
      <p>{{ $t('tariff_downgrade_info_body') }}</p>
      <p class="text-text-secondary">
        {{ $t('tariff_downgrade_info_hint') }}
      </p>
    </div>

    <template #footer>
      <div class="flex justify-end gap-3">
        <CButton @click="handleClose">
          {{ $t('close') }}
        </CButton>
        <CButton type="primary" @click="handleOpenTelegram">
          <i class="icon-telegram text-lg mr-1" />
          {{ $t('tariff_downgrade_info_cta') }}
        </CButton>
      </div>
    </template>
  </CDialog>
</template>
